/**
 * Infinity Canopy Compatibility Data
 * Source: Velocity Sports Equipment — canopy-compatibility-chart.pdf
 * All data extracted verbatim from the official VSE chart.
 *
 * reserves[X] = reserve canopies for series X (first digit of container)
 * mains[XY]  = main canopies for container I-XY (both digits)
 * Each entry: ['Brand Model', 'size(s)']
 */
window.INFINITY_CANOPY = {

  /* ────────── RESERVE CANOPIES BY SERIES ────────── */
  reserves: {

    /* I-1 Series */
    1: [
      ['PD Reserve', '113'],
      ['PD Optimum', '126'],
      ['Icarus Reserve', '109'],
      ['Icarus Nano', '126'],
      ['PA R-Max', '118'],
      ['PA Micro Raven', '120'],
      ['PA Raven Dash M', '135'],
      ['Aerodyne Smart', '120'],
      ['PISA Tempo', '120']
    ],

    /* I-2 Series */
    2: [
      ['PD Reserve', '126'],
      ['PD Optimum', '143'],
      ['Icarus Reserve', '119'],
      ['Icarus Nano', '143'],
      ['PA R-Max', '128'],
      ['PA Micro Raven', '135'],
      ['PA Raven Dash M', '135'],
      ['Aerodyne Smart', '135']
    ],

    /* I-3 Series */
    3: [
      ['PD Reserve', '143'],
      ['PD Optimum', '160'],
      ['Icarus Reserve', '139'],
      ['Icarus Nano', '160'],
      ['PA R-Max', '148'],
      ['PA Micro Raven', '150'],
      ['PA Raven Dash M', '150'],
      ['Aerodyne Smart', '150'],
      ['PISA Tempo', '150']
    ],

    /* I-4 Series */
    4: [
      ['PD Reserve', '160, 176'],
      ['PD Optimum', '176, 193'],
      ['Icarus Reserve', '169'],
      ['Icarus Nano', '193'],
      ['PA R-Max', '168'],
      ['PA Raven Dash M', '181'],
      ['PA Raven I', '181'],
      ['Aerodyne Smart', '175'],
      ['PISA Tempo', '170']
    ],

    /* I-5 Series */
    5: [
      ['PD Reserve', '193'],
      ['PD Optimum', '218'],
      ['Icarus Reserve', '189'],
      ['Icarus Nano', '218'],
      ['PA R-Max', '208'],
      ['PA Raven Dash M', '218'],
      ['PA Raven II', '218'],
      ['Aerodyne Smart', '190'],
      ['PISA Tempo', '210']
    ],

    /* I-6 Series */
    6: [
      ['PD Reserve', '235'],
      ['PD Optimum', '253'],
      ['Icarus Reserve', '239'],
      ['Icarus Nano', '253'],
      ['PA R-Max', '228, 248'],
      ['PA Dash M', '249'],
      ['PA Raven III', '249'],
      ['Aerodyne Smart', '220']
    ],

    /* I-7 Series */
    7: [
      ['PD Reserve', '253'],
      ['Icarus Reserve', '259'],
      ['PA R-Max', '268'],
      ['PA Dash M', '282'],
      ['PA Raven IV', '282'],
      ['Aerodyne Smart', '250']
    ]
  },

  /* ────────── MAIN CANOPIES BY CONTAINER ────────── */
  mains: {

    /* ── I-1 Series ── */

    11: [
      ['PA Xaos 27', '88'],
      ['PA Xaos 21', '88'],
      ['PA Nitron', '120'],
      ['PA Fusion', '120'],
      ['PA Synergy', '120'],
      ['PA Falcon', '120'],
      ['NZA Extreme VX', '84'],
      ['NZA Daedalus JVX', '84'],
      ['NZA Daedalus JFX', '84'],
      ['NZA Neos', '79, 84'],
      ['NZA Crossfire II', '109'],
      ['NZA Omni', '109'],
      ['NZA Safire II', '99'],
      ['PD Comp Velocity', '84'],
      ['PD Velocity', '84'],
      ['PD Katana', '107'],
      ['PD Stiletto', '107'],
      ['PD Sabre II', '107'],
      ['PD Pulse', '120'],
      ['PD Spectre', '107'],
      ['PD Storm', '107'],
      ['Aerodyne Sensei', '81'],
      ['Aerodyne Triathlon', '99'],
      ['Aerodyne Pilot', '96'],
      ['Aerodyne Mamba', '96'],
      ['Aerodyne Pilot ZPX', '104'],
      ['Aerodyne Mamba ZPX', '104'],
      ['FC Rage', '110']
    ],

    12: [
      ['PA Xaos 27', '88'],
      ['PA Xaos 21', '88'],
      ['PA Nitron', '120'],
      ['PA Fusion', '120'],
      ['PA Synergy', '120'],
      ['PA Falcon', '120'],
      ['NZA Extreme VX', '89'],
      ['NZA Daedalus JVX', '89'],
      ['NZA Daedalus JFX', '89'],
      ['NZA Neos', '89, 94'],
      ['NZA Crossfire II', '119'],
      ['NZA Omni', '119'],
      ['NZA Safire II', '109'],
      ['PD Comp Velocity', '90'],
      ['PD Velocity', '90'],
      ['PD Katana', '120'],
      ['PD Stiletto', '120'],
      ['PD Sabre II', '120'],
      ['PD Pulse', '135'],
      ['PD Spectre', '120'],
      ['PD Storm', '120'],
      ['Aerodyne Sensei', '91'],
      ['Aerodyne Triathlon', '120'],
      ['Aerodyne Pilot', '111'],
      ['Aerodyne Mamba', '111'],
      ['Aerodyne Pilot ZPX', '117'],
      ['Aerodyne Mamba ZPX', '117'],
      ['FC Rage', '120']
    ],

    /* ── I-2 Series ── */

    21: [
      ['PA Xaos 27', '88'],
      ['PA Xaos 21', '88'],
      ['PA Nitron', '108'],
      ['PA Fusion', '108'],
      ['PA Synergy', '108'],
      ['NZA Extreme VX', '89'],
      ['NZA Daedalus JVX', '89'],
      ['NZA Daedalus JFX', '89'],
      ['NZA Neos', '89, 94'],
      ['NZA Crossfire II', '109'],
      ['NZA Omni', '109'],
      ['NZA Safire II', '99'],
      ['PD Comp Velocity', '96'],
      ['PD Velocity', '96'],
      ['PD Katana', '107'],
      ['PD Stiletto', '107'],
      ['PD Sabre II', '107'],
      ['PD Pulse', '120'],
      ['PD Spectre', '107'],
      ['PD Storm', '107'],
      ['Aerodyne Sensei', '91'],
      ['Aerodyne Triathlon', '99'],
      ['Aerodyne Pilot', '104'],
      ['Aerodyne Mamba', '104'],
      ['Aerodyne Pilot ZPX', '111'],
      ['Aerodyne Mamba ZPX', '111'],
      ['FC Rage', '110']
    ],

    22: [
      ['PA Xaos 27', '98'],
      ['PA Xaos 21', '98'],
      ['PA Nitron', '120'],
      ['PA Fusion', '120'],
      ['PA Synergy', '120'],
      ['PA Falcon', '120'],
      ['NZA Extreme VX', '99'],
      ['NZA Daedalus JVX', '99'],
      ['NZA Daedalus JFX', '99'],
      ['NZA Neos', '99, 104'],
      ['NZA Crossfire II', '119'],
      ['NZA Omni', '119'],
      ['NZA Safire II', '109'],
      ['PD Comp Velocity', '103'],
      ['PD Velocity', '103'],
      ['PD Katana', '120'],
      ['PD Stiletto', '120'],
      ['PD Sabre II', '120'],
      ['PD Pulse', '135'],
      ['PD Spectre', '120'],
      ['PD Storm', '120'],
      ['Aerodyne Sensei', '101'],
      ['Aerodyne Triathlon', '120'],
      ['Aerodyne Pilot', '111'],
      ['Aerodyne Mamba', '111'],
      ['Aerodyne Pilot ZPX', '117'],
      ['Aerodyne Mamba ZPX', '117'],
      ['FC Rage', '120']
    ],

    23: [
      ['PA Xaos 27', '108'],
      ['PA Xaos 21', '108'],
      ['PA Nitron', '135'],
      ['PA Fusion', '135'],
      ['PA Synergy', '135'],
      ['PA Falcon', '135'],
      ['NZA Extreme VX', '104'],
      ['NZA Daedalus JVX', '104'],
      ['NZA Daedalus JFX', '104'],
      ['NZA Neos', '109, 114'],
      ['NZA Crossfire II', '129, 139'],
      ['NZA Omni', '129, 139'],
      ['NZA Safire II', '119'],
      ['PD Comp Velocity', '111'],
      ['PD Velocity', '111'],
      ['PD Katana', '135'],
      ['PD Stiletto', '135'],
      ['PD Sabre II', '135'],
      ['PD Pulse', '150'],
      ['PD Spectre', '135'],
      ['PD Storm', '135'],
      ['PD Silhouette', '135'],
      ['Aerodyne Sensei', '111'],
      ['Aerodyne Triathlon', '135'],
      ['Aerodyne Pilot', '117'],
      ['Aerodyne Mamba', '117'],
      ['Aerodyne Pilot ZPX', '124'],
      ['Aerodyne Mamba ZPX', '124'],
      ['FC Rage', '130']
    ],

    24: [
      ['PA Xaos 27', '118'],
      ['PA Xaos 21', '118'],
      ['PA Nitron', '150'],
      ['PA Fusion', '150'],
      ['PA Synergy', '150'],
      ['PA Falcon', '150'],
      ['NZA Extreme VX', '114, 119'],
      ['NZA Daedalus JVX', '114, 119'],
      ['NZA Daedalus JFX', '114, 119'],
      ['NZA Neos', '119'],
      ['NZA Crossfire II', '139, 149'],
      ['NZA Omni', '149'],
      ['NZA Safire II', '139, 149'],
      ['PD Velocity', '120'],
      ['PD Katana', '150'],
      ['PD Stiletto', '150'],
      ['PD Sabre II', '150'],
      ['PD Pulse', '170'],
      ['PD Spectre', '150'],
      ['PD Storm', '150'],
      ['PD Silhouette', '150'],
      ['PD Lightning', '143'],
      ['Aerodyne Sensei', '121'],
      ['Aerodyne Triathlon', '150'],
      ['Aerodyne Pilot', '132'],
      ['Aerodyne Mamba', '132, 140'],
      ['Aerodyne Pilot ZPX', '140'],
      ['Aerodyne Mamba ZPX', '140, 150'],
      ['FC Rage', '140']
    ],

    /* ── I-3 Series ── */

    32: [
      ['PA Xaos 27', '108'],
      ['PA Xaos 21', '108'],
      ['PA Nitron', '135'],
      ['PA Fusion', '135'],
      ['PA Synergy', '135'],
      ['PA Falcon', '135'],
      ['NZA Extreme VX', '104'],
      ['NZA Daedalus JVX', '104'],
      ['NZA Daedalus JFX', '104'],
      ['NZA Neos', '109, 114'],
      ['NZA Crossfire II', '129'],
      ['NZA Omni', '129'],
      ['NZA Safire II', '129'],
      ['PD Comp Velocity', '111'],
      ['PD Velocity', '111'],
      ['PD Katana', '135'],
      ['PD Stiletto', '135'],
      ['PD Sabre II', '135'],
      ['PD Pulse', '150'],
      ['PD Spectre', '135'],
      ['PD Storm', '135'],
      ['PD Silhouette', '135'],
      ['Aerodyne Sensei', '111'],
      ['Aerodyne Triathlon', '135'],
      ['Aerodyne Pilot', '117, 124'],
      ['Aerodyne Mamba', '132, 140'],
      ['Aerodyne Pilot ZPX', '124, 132'],
      ['Aerodyne Mamba ZPX', '140, 150'],
      ['FC Rage', '130']
    ],

    33: [
      ['PA Xaos 27', '118'],
      ['PA Xaos 21', '118'],
      ['PA Nitron', '150'],
      ['PA Fusion', '150'],
      ['PA Synergy', '150'],
      ['PA Falcon', '150'],
      ['NZA Extreme VX', '114'],
      ['NZA Daedalus JVX', '114'],
      ['NZA Daedalus JFX', '114'],
      ['NZA Neos', '119'],
      ['NZA Crossfire II', '139, 149'],
      ['NZA Omni', '139, 149'],
      ['NZA Safire II', '139, 149'],
      ['PD Lightning', 'Demo 143 / Comp 113'],
      ['PD Velocity', '120'],
      ['PD Katana', '150'],
      ['PD Stiletto', '150'],
      ['PD Sabre II', '150'],
      ['PD Pulse', '170'],
      ['PD Spectre', '150'],
      ['PD Storm', '150'],
      ['PD Silhouette', '150'],
      ['Aerodyne Sensei', '121'],
      ['Aerodyne Triathlon', '150'],
      ['Aerodyne Pilot', '140, 150'],
      ['Aerodyne Mamba', '140, 150'],
      ['Aerodyne Pilot ZPX', '140, 150'],
      ['Aerodyne Mamba ZPX', '150'],
      ['FC Rage', '140']
    ],

    34: [
      ['PA Nitron', '170'],
      ['PA Fusion', '170'],
      ['PA Synergy', '170'],
      ['PA Falcon', '170'],
      ['NZA Extreme VX', '119'],
      ['NZA Daedalus JVX', '119'],
      ['NZA Daedalus JFX', '119'],
      ['NZA Neos', '119'],
      ['NZA Crossfire II', '169'],
      ['NZA Omni', '169'],
      ['NZA Safire II', '169'],
      ['PD Lightning', 'Demo 160 / Comp 126'],
      ['PD Katana', '170'],
      ['PD Stiletto', '170'],
      ['PD Sabre II', '170'],
      ['PD Pulse', '190'],
      ['PD Spectre', '170'],
      ['PD Storm', '170'],
      ['PD Silhouette', '170'],
      ['Aerodyne Sensei', '121'],
      ['Aerodyne Triathlon', '150'],
      ['Aerodyne Pilot', '150, 168'],
      ['Aerodyne Pilot ZPX', '168, 188'],
      ['FC Rage', '155']
    ],

    /* ── I-4 Series ── */

    43: [
      ['PA Xaos 27', '118'],
      ['PA Xaos 21', '118'],
      ['PA Nitron', '150'],
      ['PA Fusion', '150'],
      ['PA Synergy', '150'],
      ['PA Falcon', '150'],
      ['NZA Extreme VX', '114'],
      ['NZA Daedalus JVX', '114'],
      ['NZA Daedalus JFX', '114'],
      ['NZA Crossfire II', '139, 149'],
      ['NZA Omni', '149'],
      ['NZA Safire II', '139, 149'],
      ['PD Velocity', '120'],
      ['PD Katana', '150'],
      ['PD Stiletto', '150'],
      ['PD Sabre II', '150'],
      ['PD Pulse', '170'],
      ['PD Spectre', '150'],
      ['PD Storm', '150'],
      ['PD Silhouette', '150'],
      ['Aerodyne Sensei', '121'],
      ['Aerodyne Triathlon', '150'],
      ['Aerodyne Pilot', '132, 140'],
      ['Aerodyne Mamba', '150'],
      ['Aerodyne Pilot ZPX', '140'],
      ['Aerodyne Mamba ZPX', '140, 150'],
      ['FC Rage', '155']
    ],

    44: [
      ['PA Nitron', '170'],
      ['PA Fusion', '170'],
      ['PA Synergy', '170'],
      ['PA Falcon', '175'],
      ['PA Voyager', '180'],
      ['NZA Extreme VX', '119'],
      ['NZA Daedalus JVX', '119'],
      ['NZA Daedalus JFX', '119'],
      ['NZA Crossfire II', '169'],
      ['NZA Omni', '169'],
      ['NZA Safire II', '169'],
      ['PD Lightning', 'Demo 160 / Comp 126'],
      ['PD Katana', '170'],
      ['PD Stiletto', '170'],
      ['PD Sabre II', '170'],
      ['PD Pulse', '190'],
      ['PD Spectre', '170'],
      ['PD Storm', '170'],
      ['PD Silhouette', '170'],
      ['Aerodyne Triathlon', '160, 175'],
      ['Aerodyne Pilot', '150, 168'],
      ['Aerodyne Pilot ZPX', '168'],
      ['FC Rage', '155']
    ],

    45: [
      ['PA Fusion', '190'],
      ['PA Synergy', '190'],
      ['PA Falcon', '195'],
      ['PA Voyager', '200'],
      ['NZA Equinox', '189'],
      ['NZA Crossfire II', '189'],
      ['NZA Omni', '189'],
      ['NZA Safire II', '189'],
      ['PD Lightning', 'Demo 176 / Comp 143'],
      ['PD Stiletto', '190'],
      ['PD Sabre II', '190'],
      ['PD Pulse', '210'],
      ['PD Spectre', '190'],
      ['PD Storm', '190'],
      ['PD Silhouette', '190'],
      ['Aerodyne Triathlon', '190'],
      ['Aerodyne Pilot', '168, 188'],
      ['Aerodyne Pilot ZPX', '188, 210'],
      ['Aerodyne Solo', '190'],
      ['Aerodyne Solo ZPX', '210'],
      ['FC Rage', '155']
    ],

    46: [
      ['PA Fusion', '210'],
      ['PA Synergy', '210'],
      ['PA Falcon', '215'],
      ['PA Voyager', '220'],
      ['NZA Equinox', '209'],
      ['NZA Safire II', '209'],
      ['PD Lightning', 'Demo 193 / Comp 160'],
      ['PD Navigator', '200'],
      ['PD Sabre II', '210'],
      ['PD Pulse', '230'],
      ['PD Spectre', '210'],
      ['PD Storm', '210'],
      ['PD Silhouette', '210'],
      ['Aerodyne Triathlon', '210'],
      ['Aerodyne Pilot', '188, 210'],
      ['Aerodyne Pilot ZPX', '210, 230'],
      ['FC Rage', '155']
    ],

    /* ── I-5 Series ── */

    54: [
      ['PA Nitron', '170'],
      ['PA Fusion', '170'],
      ['PA Synergy', '170'],
      ['PA Falcon', '175'],
      ['PA Voyager', '180'],
      ['NZA Crossfire II', '169'],
      ['NZA Omni', '169'],
      ['NZA Safire II', '169'],
      ['PD Lightning', 'Demo 160 / Comp 126'],
      ['PD Katana', '170'],
      ['PD Stiletto', '170'],
      ['PD Sabre II', '170'],
      ['PD Pulse', '190'],
      ['PD Spectre', '170'],
      ['PD Storm', '170'],
      ['PD Silhouette', '170'],
      ['Aerodyne Triathlon', '160, 175'],
      ['Aerodyne Pilot', '150, 168'],
      ['Aerodyne Pilot ZPX', '168, 188'],
      ['FC Rage', '155']
    ],

    55: [
      ['PA Fusion', '190'],
      ['PA Synergy', '190'],
      ['PA Falcon', '195'],
      ['PA Voyager', '200'],
      ['NZA Equinox', '189'],
      ['NZA Crossfire II', '189'],
      ['NZA Omni', '189'],
      ['NZA Safire II', '189'],
      ['PD Lightning', 'Demo 176 / Comp 143'],
      ['PD Stiletto', '190'],
      ['PD Sabre II', '190'],
      ['PD Pulse', '210'],
      ['PD Spectre', '190'],
      ['PD Storm', '190'],
      ['PD Silhouette', '190'],
      ['Aerodyne Triathlon', '190'],
      ['Aerodyne Pilot', '168, 188'],
      ['Aerodyne Pilot ZPX', '188, 210'],
      ['Aerodyne Solo', '190'],
      ['Aerodyne Solo ZPX', '210'],
      ['FC Rage', '155']
    ],

    56: [
      ['PA Fusion', '210'],
      ['PA Synergy', '210'],
      ['PA Falcon', '215'],
      ['PA Voyager', '220'],
      ['NZA Equinox', '209'],
      ['NZA Safire II', '209'],
      ['PD Lightning', 'Demo 193 / Comp 160'],
      ['PD Navigator', '200'],
      ['PD Sabre II', '210'],
      ['PD Pulse', '230'],
      ['PD Spectre', '210'],
      ['PD Storm', '210'],
      ['PD Silhouette', '210'],
      ['Aerodyne Triathlon', '210'],
      ['Aerodyne Pilot', '188, 210'],
      ['Aerodyne Pilot ZPX', '210, 230'],
      ['Aerodyne Solo', '210'],
      ['Aerodyne Solo ZPX', '230'],
      ['FC Rage', '155']
    ],

    57: [
      ['PA Fusion', '230'],
      ['PA Synergy', '230'],
      ['PA Falcon', '235'],
      ['NZA Safire II', '229'],
      ['PD Lightning', 'Demo 218 / Comp 176'],
      ['PD Navigator', '220'],
      ['PD Sabre II', '230'],
      ['PD Pulse', '260'],
      ['PD Spectre', '230'],
      ['PD Storm', '230'],
      ['PD Silhouette', '230'],
      ['Aerodyne Triathlon', '220'],
      ['Aerodyne Solo', '230'],
      ['Aerodyne Solo ZPX', '250'],
      ['Aerodyne Pilot', '230'],
      ['FC Rage', '155']
    ],

    /* ── I-6 Series ── */

    65: [
      ['PA Fusion', '190'],
      ['PA Synergy', '190'],
      ['PA Falcon', '195'],
      ['PA Voyager', '200'],
      ['NZA Equinox', '189'],
      ['NZA Crossfire II', '189'],
      ['NZA Omni', '189'],
      ['NZA Safire II', '189'],
      ['PD Lightning', 'Demo 176 / Comp 143'],
      ['PD Stiletto', '190'],
      ['PD Sabre II', '190'],
      ['PD Pulse', '210'],
      ['PD Spectre', '190'],
      ['PD Storm', '190'],
      ['PD Silhouette', '190'],
      ['Aerodyne Triathlon', '190'],
      ['Aerodyne Solo', '190'],
      ['Aerodyne Solo ZPX', '210'],
      ['Aerodyne Pilot', '168, 188'],
      ['Aerodyne Pilot ZPX', '188, 210'],
      ['FC Rage', '155']
    ],

    66: [
      ['PA Fusion', '210'],
      ['PA Synergy', '210'],
      ['PA Falcon', '215'],
      ['PA Voyager', '220'],
      ['NZA Equinox', '209'],
      ['NZA Safire II', '209'],
      ['PD Lightning', 'Demo 193 / Comp 160'],
      ['PD Navigator', '200'],
      ['PD Sabre II', '210'],
      ['PD Pulse', '230'],
      ['PD Spectre', '210'],
      ['PD Storm', '210'],
      ['PD Silhouette', '210'],
      ['Aerodyne Triathlon', '210'],
      ['Aerodyne Solo', '210'],
      ['Aerodyne Solo ZPX', '230'],
      ['Aerodyne Pilot', '188, 210'],
      ['Aerodyne Pilot ZPX', '210, 230'],
      ['FC Rage', '155']
    ],

    67: [
      ['PA Fusion', '230'],
      ['PA Synergy', '230'],
      ['PA Falcon', '235'],
      ['NZA Safire II', '229'],
      ['PD Lightning', 'Demo 218 / Comp 176'],
      ['PD Navigator', '220'],
      ['PD Sabre II', '230'],
      ['PD Pulse', '260'],
      ['PD Spectre', '230'],
      ['PD Storm', '230'],
      ['PD Silhouette', '230'],
      ['Aerodyne Triathlon', '220'],
      ['Aerodyne Solo', '230'],
      ['Aerodyne Solo ZPX', '250'],
      ['Aerodyne Pilot', '210'],
      ['Aerodyne Pilot ZPX', '188, 210'],
      ['FC Rage', '155']
    ],

    68: [
      ['PA Fusion', '230'],
      ['PA Synergy', '230'],
      ['PA Falcon', '235'],
      ['NZA Safire II', '229'],
      ['PD Lightning', 'Demo 218 / Comp 176'],
      ['PD Navigator', '220'],
      ['PD Sabre II', '230'],
      ['PD Pulse', '260'],
      ['PD Spectre', '230'],
      ['PD Storm', '230'],
      ['PD Silhouette', '230'],
      ['Aerodyne Triathlon', '220'],
      ['Aerodyne Solo', '230'],
      ['Aerodyne Solo ZPX', '250'],
      ['Aerodyne Pilot', '210'],
      ['Aerodyne Pilot ZPX', '188, 210'],
      ['FC Rage', '155']
    ],

    /* ── I-7 Series ── */

    76: [
      ['PA Fusion', '230'],
      ['PA Synergy', '230'],
      ['PA Falcon', '235'],
      ['NZA Safire II', '229'],
      ['PD Lightning', 'Demo 218 / Comp 176'],
      ['PD Navigator', '220'],
      ['PD Sabre II', '230'],
      ['PD Pulse', '260'],
      ['PD Spectre', '230'],
      ['PD Storm', '230'],
      ['PD Silhouette', '230'],
      ['Aerodyne Triathlon', '220'],
      ['Aerodyne Solo', '230'],
      ['Aerodyne Solo ZPX', '250'],
      ['Aerodyne Pilot', '210'],
      ['Aerodyne Pilot ZPX', '188, 210'],
      ['FC Rage', '155']
    ],

    77: [
      ['PA Falcon', '265'],
      ['PA Voyager', '260'],
      ['NZA Equinox', '259'],
      ['PD Lightning', 'Demo 176 / Comp 143'],
      ['PD Navigator', '260'],
      ['PD Sabre II', '260'],
      ['PD Pulse', '260'],
      ['PD Silhouette', '260'],
      ['Aerodyne Triathlon', '260'],
      ['Aerodyne Solo', '250'],
      ['Aerodyne Solo ZPX', '270'],
      ['Aerodyne Pilot', '168, 188'],
      ['Aerodyne Pilot ZPX', '188, 210'],
      ['FC Rage', '155']
    ]
  }
};
